import { css as e, styled as t } from "styled-components";
//#region src/components/Carousel/styled/CarouselControls.styled.ts
var n = t.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ theme: e }) => e.spacing(1)};
    min-height: 32px;
`, r = t.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme: e }) => e.spacing(.25)};
    min-width: 0;
`, i = e`
    display: inline-flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(1)};
    background: none;
    border: none;
    padding: 0;
    cursor: ${({ $clickable: e }) => e ? "pointer" : "default"};
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.base};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.semibold};
    color: ${({ theme: e }) => e.colors.foreground};
    text-align: left;
    transition: color ${({ theme: e }) => e.transitions.fast};

    ${({ $clickable: t, theme: n }) => t && e`
            &:hover {
                color: ${n.colors.primary};
            }
        `}
`, a = t.button`
    ${i}
`, o = t.a`
    ${i}
    text-decoration: none;
`, s = t.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    color: ${({ theme: e }) => e.colors.mutedForeground};
`, c = t.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(.5)};
    flex-shrink: 0;
`, l = t.span`
    font-family: ${({ theme: e }) => e.typographyTokens.fontFamily};
    font-size: ${({ theme: e }) => e.typographyTokens.sizes.sm};
    font-weight: ${({ theme: e }) => e.typographyTokens.weights.medium};
    color: ${({ theme: e }) => e.colors.mutedForeground};
    /* Tabular so "9 / 10" does not shuffle the arrows sideways as it advances. */
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
    flex-shrink: 0;
    margin-right: ${({ theme: e }) => e.spacing(.5)};

    @media (max-width: 640px) {
        display: none;
    }
`, u = t.div`
    display: flex;
    align-items: center;
    gap: ${({ theme: e }) => e.spacing(.5)};
    flex-shrink: 0;
    /* Arrow buttons add no value on touch screens — swipe does the job */
    @media (max-width: 640px) {
        display: none;
    }
`, d = t.button`
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ $size: e }) => e === "sm" ? "24px" : "32px"};
    height: ${({ $size: e }) => e === "sm" ? "24px" : "32px"};
    border-radius: ${({ theme: e }) => e.radii.full};
    border: ${({ theme: e, $variant: t }) => t === "transparent" ? "none" : `1px solid ${e.colors.border}`};
    background: ${({ theme: e, $variant: t }) => t === "transparent" ? "rgba(255, 255, 255, 0.4)" : e.colors.card};
    backdrop-filter: ${({ $variant: e }) => e === "transparent" ? "blur(4px)" : "none"};
    color: ${({ theme: e, $variant: t }) => t === "transparent" ? "#fff" : e.colors.foreground};
    cursor: pointer;
    transition: all ${({ theme: e }) => e.transitions.fast};
    box-shadow: ${({ theme: e, $variant: t }) => t === "transparent" ? "none" : e.shadows.sm};
    opacity: ${({ $disabled: e }) => e ? 0 : 1};
    pointer-events: ${({ $disabled: e }) => e ? "none" : "auto"};

    &:hover {
        background: ${({ theme: e, $variant: t }) => t === "transparent" ? "rgba(255, 255, 255, 0.8)" : e.colors.accent};
        border-color: ${({ theme: e, $variant: t }) => t === "transparent" ? "none" : e.colors.primary};
        color: ${({ theme: e, $variant: t }) => t === "transparent" ? "#000" : e.colors.primary};
    }
`, f = t(d)`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${({ $side: e }) => e === "left" ? "left: 8px;" : "right: 8px;"}
    z-index: 10;
`, p = t.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme: e }) => e.spacing(.75)};
    margin-top: ${({ theme: e, $overlay: t }) => t ? "0" : e.spacing(1)};
    position: ${({ $overlay: e }) => e ? "absolute" : "relative"};
    bottom: ${({ $overlay: e }) => e ? "8px" : "auto"};
    left: ${({ $overlay: e }) => e ? "0" : "auto"};
    width: 100%;
    z-index: 10;
`, m = t.button`
    width: ${({ $active: e }) => e ? "20px" : "8px"};
    height: 8px;
    border-radius: ${({ theme: e }) => e.radii.full};
    border: none;
    background: ${({ theme: e, $active: t, $overlay: n }) => n ? t ? "#fff" : "rgba(255,255,255,0.6)" : t ? e.colors.primary : e.colors.border};
    box-shadow: ${({ $overlay: e }) => e ? "0 1px 3px rgba(0,0,0,0.3)" : "none"};
    cursor: pointer;
    padding: 0;
    transition: all ${({ theme: e }) => e.transitions.normal};
    &:hover {
        background: ${({ theme: e, $overlay: t }) => t ? "#fff" : e.colors.primary};
    }
`, h = t.button`
    width: 8px;
    height: ${({ $active: e }) => e ? "20px" : "8px"};
    border-radius: ${({ theme: e }) => e.radii.full};
    border: none;
    background: ${({ theme: e, $active: t }) => t ? e.colors.primary : e.colors.border};
    cursor: pointer;
    padding: 0;
    transition: all ${({ theme: e }) => e.transitions.normal};
    &:hover {
        background: ${({ theme: e }) => e.colors.primary};
    }
`;
//#endregion
export { d as ArrowBtn, u as ArrowGroup, m as Dot, p as DotsRow, c as HeaderEnd, n as HeaderRow, f as OverlayArrowBtn, l as PageIndicator, s as Subtitle, r as TitleBlock, a as TitleButton, o as TitleLink, h as VerticalDot };
